import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/translations";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("vk_lang") || "de");
  const [theme, setTheme] = useState(() => localStorage.getItem("vk_theme") || "light");

  useEffect(() => {
    localStorage.setItem("vk_lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("vk_theme", theme);
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
  }, [theme]);

  const t = (key) => translations[lang][key] ?? key;
  const toggleLang = () => setLang((l) => (l === "de" ? "en" : "de"));
  const toggleTheme = () => setTheme((tm) => (tm === "light" ? "dark" : "light"));

  return (
    <AppContext.Provider value={{ lang, theme, t, toggleLang, toggleTheme }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
